/**
 * Utility to clean objects by removing undefined values recursively
 * Used for Firebase data preparation
 */

export function cleanObject<T>(obj: T): T {
    if (Array.isArray(obj)) {
        const cleaned = (obj as unknown[]).map(v => 
            v && typeof v === 'object' && !(v instanceof Date) ? cleanObject(v as Record<string, unknown>) : v
        ).filter(v => v !== undefined);
        return cleaned as T;
    }
    
    const cleaned: Record<string, unknown> = {};
    (Object.entries(obj as object))
        .filter(([_, v]) => v !== undefined)
        .forEach(([k, v]) => {
            cleaned[k] = v && typeof v === 'object' && !(v instanceof Date) 
                ? cleanObject(v as Record<string, unknown>) 
                : v;
        });
    
    return cleaned as T;
}

export default cleanObject;
